// ServiceEditor.js

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import DashboardServ from '../../services/externalServices/dashBoardServices';

function ServiceEditor() {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    description: "",
    image_url: "",
    route: "",
    active: "",
    dashboard_portion: "",
    tags: [],
    priority: ""
  });

  useEffect(() => {
    getService(id);
  }, [id]);

  const getService = async (id) => {
    try {
      // const response = await axios.get(`http://localhost:8080/dashboard_services/${id}`);
      const response=await DashboardServ.Services(id);
      setService(response);
      // Set initial form data from service data
      setFormData({
        name: response.name,
        title: response.title,
        description: response.description,
        image_url: response.image_url,
        route: response.route,
       active: response.active ? "true" : "false",  // Convert active to string if it's a boolean
        dashboard_portion: response.dashboard_portion,
        tags: response.tags.join(", "), // Convert tags array to string
        priority: response.priority.toString() // Convert priority to string if it's a number
      });
    } catch (error) {
      console.error("Error while getting service ", error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Make API call to update service with formData
      // await axios.put(`http://localhost:8080/dashboard_services/${id}`, formData);
       const submissionData = {
        ...formData,
        active: formData.active === "true", // Convert string to boolean
        // Convert tags back to array if needed
        tags: formData.tags.split(",").map(tag => tag.trim())
      };
      
      await DashboardServ.updateServices(id, submissionData);
      alert("Service updated successfully!");
      // Optionally, you can redirect the user to another page after updating the service
    } catch (error) {
      console.error("Error while updating service ", error);
    }
  };

  if (!service) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container">
      <h1 className="mt-3">Edit Service</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name:</label>
          <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Title:</label>
          <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Description:</label>
          <textarea className="form-control" name="description" value={formData.description} onChange={handleChange}></textarea>
        </div>
        <div className="form-group">
          <label>Image URL:</label>
          <input type="text" className="form-control" name="image_url" value={formData.image_url} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Route:</label>
          <input type="text" className="form-control" name="route" value={formData.route} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Active:</label>
          <select className="form-control" name="active" value={formData.active} onChange={handleChange}>
            <option value="true">True</option>
            <option value="false">False</option>
          </select>
        </div>
        <div className="form-group">
          <label>Dashboard Portion:</label>
          <input type="text" className="form-control" name="dashboard_portion" value={formData.dashboard_portion} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Tags:</label>
          <input type="text" className="form-control" name="tags" value={formData.tags} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Priority:</label>
          <input type="text" className="form-control" name="priority" value={formData.priority} onChange={handleChange} />
        </div>
        <button type="submit" className="btn btn-primary">Save</button>
      </form>
    </div>
  );
}

export default ServiceEditor;
